import ParallaxImage from './module/ParallaxImage';
import TypeWriterText from './module/TypeWriterText';

(() => {

	const parallaxImageInit = () => {
		const dataAttrPref = 'data-parallax';
		document.querySelectorAll(`[${dataAttrPref}-wrap]`).forEach(wrap => {
			const item = wrap.querySelector(`[${dataAttrPref}-item]`);
			const speedAttr = wrap.getAttribute(`${dataAttrPref}-speed`);
			new ParallaxImage({ wrap, item, speedAttr });
		});
	};

	parallaxImageInit();

    const typeWriterObserverInit = () => {
        const dataAttrPref = 'data-typewriter';

		const typeWriterInit = (targetElement) => {
			if (targetElement.getAttribute('data-typewriter-init')) return; // 既に初期化されている場合はスキップ
			targetElement.setAttribute('data-typewriter-init', 'true'); // 初期化済みフラグをセット

			const classesToAdd = targetElement.getAttribute(`${dataAttrPref}-add-class`); // 適用するクラス
			const typingSpeed = parseInt(targetElement.getAttribute(`${dataAttrPref}-speed`)); // タイピングスピード
			const tagType = 'span'; // 挿入するタグ
			new TypeWriterText({
				targetElement,
				classesToAdd,
				typingSpeed,
				tagType
			});
		};

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    typeWriterInit(entry.target);
                }
            });
        });

        document.querySelectorAll(`[${dataAttrPref}]`).forEach(targetElement => {
            observer.observe(targetElement);
        });
    };

    typeWriterObserverInit();

})();

